import { logWrapper } from '../utils';

export default {
  folderModel: [
    'runtimeConstant',
    '$rootScope',
    function (runtimeConstant, $rootScope) {
      function Folder(data) {
        if (!data) {
          data = {
            Id: 0,
            IdParent: 0,
            Name: '',
            Acronym: '',
            InheritAcronym: false,
            Parent: null,
            Description: '',
            Path: '',
            IsOpen: false,
            CanManageFolder: false,
            Features: null,
            Children: null,
            HasChildren: false,
            HasPermission: false,
          };
        }

        this.id = data.Id;
        this.idParent = data.IdParent;
        this.name = data.Name;
        this.acronym = data.Acronym;
        this.inheritAcronym = data.InheritAcronym;
        if (data.Parent) {
          this.parent = new Folder(data.Parent);
        }
        this.description = data.Description;
        this.path = data.Path;

        this.canManageFolder = data.CanManageFolder ? true : false;
        this.canCreateFolder = data.CanCreateFolder ? true : false;
        this.features = data.Features;
        this.children = data.Children;
        this.hasChildren = data.HasChildren ? true : false;
        this.hasPermission = data.HasPermission ? true : false;
        this.isOpen = data.IsOpen;
        this._selected = false;
      }

      function title() {
        return this.name;
      }

      function icon() {
        // icons: repository, folder, doctype, additionalFields
        var icons = [
          'md-repository',
          'md-doc-folder',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        // icons: repositorio e pasta desabilitados
        var disabledIcons = [
          'md-repository-disabled',
          'md-folder-disabled',
          'md-doc-type',
          'md-add-fields',
          'md-loading',
        ];

        if (Array.isArray(this.permissions) && this.permissions.length > 0) {
          //Retorna os icones habilitados
          return icons[this.treeItemType];
        } else {
          return disabledIcons[this.treeItemType];
        }
      }

      function selected(value) {
        if (arguments.length) {
          this._selected = value;
          this.isOpen = true;
          var that = this;

          if (Array.isArray(this.children) && this.children.length > 0) {
            that.recursiveSelect(value);
            $rootScope.$broadcast('crudCurrentItemEvent', {
              event: 'updateSelectedFolders',
            });
          } else {
            $rootScope.$broadcast('crudCurrentItemEvent', {
              event: 'updateSelectedFolders',
            });
          }
        } else {
          return this._selected;
        }
      }

      function recursiveSelect(value) {
        if (arguments.length) {
          this._selected = value;
          if (Array.isArray(this.children)) {
            for (var i = 0, len = this.children.length; i < len; i++) {
              this.children[i].recursiveSelect(value);
            }
          }
        }
      }

      function run() {
        try {
          Folder.prototype = {
            title: logWrapper(title, runtimeConstant.isDebugModelsInternals),
            icon: logWrapper(icon, runtimeConstant.isDebugModelsInternals),
            selected: logWrapper(
              selected,
              runtimeConstant.isDebugModelsInternals
            ),
            recursiveSelect: logWrapper(
              recursiveSelect,
              runtimeConstant.isDebugModelsInternals
            ),
          };

          return Folder;
        } catch (error) {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      }

      // Wrap the setup function with logWrapper for debugging purposes
      return logWrapper(run, runtimeConstant.isDebugModels)();
    },
  ],
};
